"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nextUi = require("@tinper/next-ui");

var _FormInputControl = _interopRequireDefault(require("./FormInputControl.js"));

var _modal = _interopRequireDefault(require("./modal.js"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Option = _nextUi.Select.Option;

if (!(typeof process !== 'undefined' && process.versions != null && process.versions.node != null)) {
  require('./index.css');
}

var FormItem = _nextUi.Form.Item;
var propTypes = {
  className: _propTypes["default"].string,
  status: _propTypes["default"].string,
  onOk: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  locale: _propTypes["default"].string.isRequired,
  localeList: _propTypes["default"].object.isRequired,
  onChange: _propTypes["default"].func,
  isTextarea: _propTypes["default"].bool,
  modalLocale: _propTypes["default"].object,
  backdrop: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  showIcon: _propTypes["default"].bool
};
var defaultProps = {
  classnames: '',
  status: 'preview',
  isTextarea: false,
  backdrop: true,
  required: false,
  showIcon: true
};
var AC_DEFAULT_SYSLOCALE = 'zh_CN';
var AC_DEFAULT_LOCALELIST = {
  'zh_CN': ''
};
var GLOBAL_LANGUAGE = {
  'zh_CN': 'CN',
  'en_US': 'EN',
  'zh_TW': 'TC',
  'fr_FR': 'FR',
  'de_DE': 'DE',
  'ja_JP': 'JP'
};

var getContent = function getContent(localeList, modalLocale, locale) {
  return Object.keys(localeList).map(function (localeKey) {
    return _react["default"].createElement(_nextUi.Row, {
      key: 'preview' + localeKey,
      className: "input-locale-text"
    }, _react["default"].createElement("div", {
      className: "input-locale-text-r"
    }, modalLocale.label[localeKey], ":"), _react["default"].createElement("div", {
      className: "input-locale-text-l"
    }, localeList[localeKey]));
  });
};

var SPLIT_RES = {
  'UID:P_MDF-COMPS_177553A405680006': '【提示】若基准语言（<%=enterprise%>）内容未维护，系统将默认按当前语言（<%=current%>）内容赋值处理'
};

var translateCode = function translateCode(id, fun, defaultValue) {
  if (fun) {
    return lang.template(id, defaultValue);
  } else {
    if (typeof cb !== 'undefined' && typeof process !== 'undefined' && cb.lang && process.env.__LANG__ && process.env.__LANG__ == true) {
      return cb.lang.template(id, defaultValue);
    } else {
      return null;
    }
  }
};

var translateSplitCode = function translateSplitCode(id, fun, data) {
  if (fun) {
    return lang.template(id, data);
  } else {
    if (typeof cb !== 'undefined' && cb.lang && process.env.__LANG__ && process.env.__LANG__ == true) {
      return cb.lang.template(id, data);
    } else {
      var value = SPLIT_RES[id];

      if (!value) {
        console.log('未连接多语中心的词条:' + key + '不存在,请检查词条!');
        return id;
      }

      for (var name in data) {
        value = value.replace('<%=' + name + '%>', data[name]);
      }

      return value;
    }
  }
};

var transLanguage = function transLanguage() {
  var local = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var res = GLOBAL_LANGUAGE[local];

  if (!res) {
    res = local.split('_')[1];
  }

  return res;
};

var AcInputLocale = function (_Component) {
  (0, _inherits2["default"])(AcInputLocale, _Component);

  var _super = _createSuper(AcInputLocale);

  function AcInputLocale(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AcInputLocale);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isObjectValueEqual", function (a, b) {
      if (!_this.isPlainObject(b)) return false;
      var aProps = Object.getOwnPropertyNames(a);
      var bProps = Object.getOwnPropertyNames(b);

      if (aProps.length != bProps.length) {
        return false;
      }

      for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];

        if (_this.isPlainObject(a[propName]) && _this.isPlainObject(b[propName])) {
          var judge = _this.isObjectValueEqual(a[propName], b[propName]);

          if (!judge) {
            return false;
          }
        } else if (a[propName] !== b[propName]) {
          return false;
        }
      }

      return true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnterIcon", function () {
      _this.isMouseEnterIcon = true;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeaveIcon", function () {
      _this.isMouseEnterIcon = false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onClose", function () {
      _this.isMouseEnterIcon = false;

      _this.setState({
        showModal: false,
        focused: true,
        error: ''
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "open", function (event) {
      event.stopPropagation();
      var status = _this.props.status;

      if (status === 'preview') {
        return;
      }

      _this.firstClickIcon = false;
      _this.isMouseEnterIcon = true;

      _this.setState({
        showModal: true,
        focused: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showIconClick", function (event, _localeList) {
      var _this$state = _this.state,
          sysLocale = _this$state.sysLocale,
          locale = _this$state.locale;

      if (!_localeList[sysLocale]) {
        _localeList[sysLocale] = _localeList[locale];
      }

      ;

      if (!_this.equalLang(_localeList, _this.state._localeList)) {
        _this.setState({
          _localeList: _localeList
        });
      }

      ;

      _this.open(event);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onOk", function () {
      var _this$state2 = _this.state,
          localeList = _this$state2.localeList,
          _localeList = _this$state2._localeList,
          locale = _this$state2.locale,
          required = _this$state2.required;
      var inputId = _this.props.inputId;

      if (required && (!String(_localeList[locale]).trim() || !_localeList[locale])) {
        _this.setState({
          error: _this.state.modalLocale.errorMsg
        });

        return;
      }

      var validatedArray = [];
      var fireChange = false;

      if (!_localeList[_this.state.sysLocale]) {
        _localeList[_this.state.sysLocale] = _localeList[_this.state.locale];
      }

      Object.keys(_localeList).forEach(function (localeKey) {
        _localeList[localeKey] = _localeList[localeKey] ? String(_localeList[localeKey]).trim() : _localeList[localeKey];
        validatedArray.push(inputId + '_' + localeKey);

        if (localeList[localeKey] != _localeList[localeKey]) {
          localeList[localeKey] = _localeList[localeKey];
          fireChange = true;
        }
      });

      if (required) {
        var obj = {};
        obj[_this.props.inputId] = _localeList[locale];

        _this.props.form.validateFields(validatedArray, function (err, values) {
          if (err) {
            console.log('validate failed', values);

            _this.setState({
              error: true
            });
          } else {
            _this.props.form.setFieldsValue(obj);

            _this.props.onOk && _this.props.onOk(_localeList);

            _this.onClose();

            fireChange && _this.onChange(_localeList[locale], _localeList, true);
          }
        });
      } else {
        _this.props.onOk && _this.props.onOk(_localeList);

        _this.onClose();

        fireChange && _this.onChange(_localeList[locale], _localeList, true);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCancel", function () {
      var _localeList = JSON.parse(JSON.stringify(_this.state.localeList));

      _this.setState({
        _localeList: _localeList
      });

      _this.onClose();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "stringTrim", function (str) {
      return str.replace(/^\s+|\s+$/gm, '');
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkValidValue", function (rule, value, callback) {
      var self = (0, _assertThisInitialized2["default"])(_this);
      var _self$state = self.state,
          required = _self$state.required,
          localeList = _self$state.localeList,
          locale = _self$state.locale,
          sysLocale = _self$state.sysLocale;
      var translateFun = self.props.translateFun;
      var currentLanguage = self.state.modalLocale ? self.state.modalLocale.currentLang : translateCode('UID:P_MDF-COMPS_1772AAEE05180009', translateFun, '当前语种') || '当前语种';
      var defaultLanguage = self.state.modalLocale ? self.state.modalLocale.defaultLang : translateCode('UID:P_MDF-COMPS_1772AAEE0518000A', translateFun, '默认语种') || '默认语种';
      var errMessage = self.state.modalLocale ? self.state.modalLocale.errorMsg : translateCode('UID:P_MDF-COMPS_1772AAEE05180008', translateFun, '不能为空') || '不能为空';

      if (required) {
        if (!self.stringTrim(localeList[locale])) {
          callback(currentLanguage + ' ' + errMessage);
        }

        if (!self.stringTrim(localeList[sysLocale])) {
          callback(defaultLanguage + ' ' + errMessage);
        }
      }

      callback();
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "renderLabelright", function (localeKey) {
      var _this$state3 = _this.state,
          locale = _this$state3.locale,
          sysLocale = _this$state3.sysLocale,
          required = _this$state3.required;

      if (required) {
        if (locale == sysLocale) {
          if (localeKey == locale) {
            return _react["default"].createElement("span", {
              className: "require-star",
              style: {
                'float': 'right'
              }
            }, "*");
          }
        } else {
          if (localeKey == locale) {
            return _react["default"].createElement("span", {
              className: "require-star",
              style: {
                'float': 'right'
              }
            }, "*");
          }
        }
      }

      return _react["default"].createElement("span", {
        className: "require-star",
        style: {
          'float': 'right'
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getMultiOrderList", function (localeList) {
      var _this$props = _this.props,
          locale = _this$props.locale,
          sysLocale = _this$props.sysLocale,
          multiOrderList = _this$props.multiOrderList;
      var orderList = [];
      orderList.push(locale);
      if (sysLocale !== locale) orderList.push(sysLocale);

      for (var _key in localeList) {
        if (orderList.indexOf(_key) == -1) orderList.push(_key);
      }

      if (multiOrderList && multiOrderList.length) {
        orderList = multiOrderList;
      }

      return orderList;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "forceSyncChange", function (localeList, value) {
      var _this$props2 = _this.props,
          inputId = _this$props2.inputId,
          form = _this$props2.form;
      Object.keys(localeList).forEach(function (item) {
        localeList[item] = value;

        if (form) {
          var setFieldsValue = form.setFieldsValue;

          var _key2 = "".concat(inputId, "_").concat(item);

          var obj = {};
          obj[_key2] = value;
          setFieldsValue(obj);
        }
      });
      return localeList;
    });
    var _locale = props.locale,
        _localeList2 = props.localeList,
        _status = props.status,
        modalLocale = props.modalLocale,
        _sysLocale = props.sysLocale,
        _required = props.required,
        maxLength = props.maxLength,
        placeholder = props.placeholder,
        _translateFun = props.translateFun,
        options = props.options,
        serviceCode = props.serviceCode,
        _props$minorLanLabel = props.minorLanLabel,
        minorLanLabel = _props$minorLanLabel === void 0 ? {} : _props$minorLanLabel;
    _sysLocale = _sysLocale || AC_DEFAULT_SYSLOCALE;
    _locale = _locale || _sysLocale;

    if (_this.isPlainObject(_localeList2) && Object.keys(_localeList2).length > 0) {
      _localeList2 = _objectSpread({}, _localeList2);
    } else {
      _localeList2 = _objectSpread({}, _this.getDefaultLocalList());
    }

    var localeValue = _localeList2[_locale];
    var modalLocaleTmp = Object.assign({}, {
      'title': translateCode('UID:P_MDF-COMPS_1772AAEE05180002', _translateFun, '多语言设置') || '多语言设置',
      'okName': translateCode('UID:P_MDF-COMPS_1772AAEE05180003', _translateFun, '保存') || '保存',
      'cancelName': translateCode('UID:P_MDF-COMPS_1772AAEE05180004', _translateFun, '取消') || '取消',
      'localeFlag': translateCode('UID:P_MDF-COMPS_1772AAEE05180005', _translateFun, '当前') || '当前',
      'defaultFlag': translateCode('UID:P_MDF-COMPS_1772AAEE05180006', _translateFun, '默认') || '默认',
      'placeholder': translateCode('UID:P_MDF-COMPS_1772AAEE05180007', _translateFun, '请输入...') || '请输入...',
      'errorMsg': translateCode('UID:P_MDF-COMPS_1772AAEE05180008', _translateFun, '不能为空') || '不能为空',
      'currentLang': translateCode('UID:P_MDF-COMPS_1772AAEE05180009', _translateFun, '当前语种') || '当前语种',
      'defaultLang': translateCode('UID:P_MDF-COMPS_1772AAEE0518000A', _translateFun, '默认语种') || '默认语种',
      'curLanguage': translateCode('UID:P_MDF-COMPS_1772AAEE0518000B', _translateFun, '当前语言') || '当前语言',
      'enterpriseLang': translateCode('UID:P_MDF-COMPS_1772AAEE0518000C', _translateFun, '基准语言') || '基准语言',
      'inputTips': translateCode('UID:P_MDF-COMPS_1772AAEE0518000D', _translateFun, '基准语言为空时，则默认取当前语言内容。') || '基准语言为空时，则默认取当前语言内容。',
      'label': Object.assign(minorLanLabel, {
        'zh_CN': translateCode('UID:P_MDF-COMPS_1772AAEE0518000E', _translateFun, '简体中文') || '简体中文',
        'en_US': translateCode('UID:P_MDF-COMPS_1772AAEE0518000F', _translateFun, '英文') || '英文',
        'zh_TW': translateCode('UID:P_MDF-COMPS_1772AAEE05180010', _translateFun, '繁体中文') || '繁体中文',
        'fr_FR': translateCode('UID:P_MDF-COMPS_1772AAEE05180011', _translateFun, '法语') || '法语',
        'de_DE': translateCode('UID:P_MDF-COMPS_1772AAEE05180012', _translateFun, '德语') || '德语',
        'ja_JP': translateCode('UID:P_MDF-COMPS_1772AAEE05180013', _translateFun, '日语') || '日语',
        'ko_KR': translateCode('UID:P_MDF-COMPS_1772AAEE05180014', _translateFun, '韩语') || '韩语',
        'ru_RU': translateCode('UID:P_MDF-COMPS_1772AAEE05180015', _translateFun, '俄语') || '俄语',
        'it_IT': translateCode('UID:P_MDF-COMPS_1772AAEE05180016', _translateFun, '意大利语') || '意大利语',
        'pt_PT': translateCode('UID:P_MDF-COMPS_1772AAEE05180017', _translateFun, '葡萄牙语') || '葡萄牙语'
      })
    }, modalLocale);
    _this.state = {
      localeList: JSON.parse(JSON.stringify(_localeList2)),
      _localeList: JSON.parse(JSON.stringify(_localeList2)),
      localeValue: localeValue,
      sysLocale: _sysLocale,
      locale: _locale,
      status: _status,
      required: _required,
      options: options,
      showModal: false,
      showPop: false,
      modalLocale: modalLocaleTmp,
      focused: !!_this.props.focus,
      maxLength: maxLength,
      placeholder: placeholder,
      serviceCode: serviceCode,
      gct: {
        a: 1,
        b: 'test'
      },
      error: '',
      inputError: '',
      inputFocused: {}
    };
    _this.isMouseEnterIcon = false;
    _this.firstClickIcon = true;
    _this.onClose = _this.onClose.bind((0, _assertThisInitialized2["default"])(_this));
    _this.open = _this.open.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onOk = _this.onOk.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onCancel = _this.onCancel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPressEnter = _this.onPressEnter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMouseEnterIcon = _this.onMouseEnterIcon.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMouseLeaveIcon = _this.onMouseLeaveIcon.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(AcInputLocale, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!this.isObjectValueEqual(this.props.localeList, nextProps.localeList)) {
        var locale = nextProps.locale,
            localeList = nextProps.localeList,
            sysLocale = nextProps.sysLocale;
        locale = locale || this.state.sysLocale;

        if (this.isPlainObject(localeList) && Object.keys(localeList).length > 0) {
          localeList = _objectSpread({}, localeList);
        } else {
          localeList = _objectSpread({}, this.getDefaultLocalList());
        }

        var localeValue = localeList[locale];
        this.setState({
          localeList: localeList,
          _localeList: JSON.parse(JSON.stringify(localeList)),
          localeValue: localeValue,
          locale: locale,
          sysLocale: sysLocale
        });
      }

      if (nextProps.locale !== this.props.locale && nextProps.localeList === this.props.localeList) {
        var _locale2 = nextProps.locale,
            _sysLocale2 = nextProps.sysLocale;

        if (!_locale2) {
          _locale2 = _sysLocale2 || 'zh_CN';
        }

        var _localeValue = '';
        Object.keys(nextProps.localeList).forEach(function (localeKey) {
          if (localeKey === _locale2) {
            _localeValue = nextProps.localeList[localeKey];
          }
        });
        this.setState({
          locale: _locale2,
          localeValue: _localeValue,
          sysLocale: _sysLocale2
        });
      }

      if (nextProps.status !== this.props.status) {
        this.setState({
          status: nextProps.status
        });
      }

      if (nextProps.serviceCode !== this.props.serviceCode) {
        this.setState({
          serviceCode: nextProps.serviceCode
        });
      }
    }
  }, {
    key: "getDefaultLocalList",
    value: function getDefaultLocalList() {
      return AC_DEFAULT_LOCALELIST;
    }
  }, {
    key: "isPlainObject",
    value: function isPlainObject(obj) {
      if (!obj || Object.prototype.toString.call(obj) !== '[object Object]') {
        return false;
      }

      var hasOwnConstructor = Object.prototype.hasOwnProperty.call(obj, 'constructor');
      var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && Object.prototype.hasOwnProperty.call(obj.constructor.prototype, 'isPrototypeOf');

      if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
        return false;
      }

      var key;

      for (key in obj) {}

      return typeof key === 'undefined' || Object.prototype.hasOwnProperty.call(obj, key);
    }
  }, {
    key: "getPreviewElement",
    value: function getPreviewElement(localeValue, defaultValue, localeList, modalLocale, locale) {
      return _react["default"].createElement("div", null, _react["default"].createElement(_FormInputControl["default"], {
        readOnly: true,
        fieldid: this.props.fieldid + '_preview',
        value: localeValue || defaultValue
      }), this.props.showIcon ? _react["default"].createElement(_nextUi.Popover, {
        content: getContent(localeList, modalLocale, locale),
        trigger: "hover",
        overlayClassName: "mdf-popover",
        placement: "top",
        id: "right"
      }, _react["default"].createElement("i", {
        className: "uf uf-globe input-icon",
        fieldid: this.props.fieldid + '_open'
      })) : '');
    }
  }, {
    key: "getLocaleNoFormElement",
    value: function getLocaleNoFormElement(localeList, modalLocale, locale) {
      var _this2 = this;

      var _this$props3 = this.props,
          maxLength = _this$props3.maxLength,
          isTextarea = _this$props3.isTextarea;
      var multiRenderList = this.getMultiOrderList(localeList);
      return multiRenderList.map(function (localeKey, index) {
        return _react["default"].createElement("div", {
          className: isTextarea ? 'edit-panel edit-panel-all textAreaPopover' : 'edit-panel edit-panel-all',
          key: localeKey
        }, _react["default"].createElement(FormItem, null, _react["default"].createElement("div", {
          className: "wui-form-item-label"
        }, _react["default"].createElement("label", {
          className: "wui-label",
          title: modalLocale.label[localeKey],
          style: {
            'width': '140px'
          }
        }, _react["default"].createElement("span", {
          style: {
            'float': 'right'
          }
        }, modalLocale.label[localeKey], transLanguage(localeKey)), _this2.renderLabelright(localeKey))), _react["default"].createElement("div", {
          style: {
            'display': 'inline-block',
            'width': 'calc(100% - 150px)',
            'marginLeft': '15px'
          },
          className: _this2.state.inputFocused[localeKey] ? 'focus' : ''
        }, _react["default"].createElement(_FormInputControl["default"], {
          value: localeList[localeKey],
          isTextarea: isTextarea,
          fieldid: _this2.props.fieldid + '_localeNoForm_' + index,
          placeholder: modalLocale.placeholder,
          maxLength: maxLength,
          onChange: function onChange(v) {
            var _localeList = _this2.state._localeList;
            _localeList[localeKey] = v;

            _this2.setState({
              _localeList: _localeList
            });
          },
          onFocus: function onFocus() {
            var obj = _this2.state.inputFocused;
            obj[localeKey] = true;

            _this2.setState({
              inputFocused: obj
            });
          },
          onBlur: function onBlur() {
            var obj = _this2.state.inputFocused;
            obj[localeKey] = false;

            _this2.setState({
              inputFocused: obj
            });
          }
        }))));
      });
    }
  }, {
    key: "getLocaleFormElement",
    value: function getLocaleFormElement(localeList, modalLocale, locale, getFieldProps, getFieldError) {
      var _this3 = this;

      var _this$props4 = this.props,
          maxLength = _this$props4.maxLength,
          err = _this$props4.err,
          isTextarea = _this$props4.isTextarea;
      var multiRenderList = this.getMultiOrderList(localeList);
      return multiRenderList.map(function (localeKey, index) {
        var msg = String(localeList[localeKey]).trim() && !_this3.state.error ? '' : _this3.state.modalLocale.errorMsg;

        var _input = _react["default"].createElement("div", {
          className: isTextarea ? 'textarea' : ''
        }, _react["default"].createElement(_FormInputControl["default"], (0, _extends2["default"])({
          placeholder: modalLocale.placeholder,
          isTextarea: isTextarea,
          fieldid: _this3.props.fieldid + '_localeForm_' + index,
          maxLength: maxLength,
          className: localeKey == locale && (err || _this3.state.error) && msg ? 'border-error' : ''
        }, getFieldProps(_this3.props.inputId + '_' + localeKey, {
          validateTrigger: 'onBlur',
          initialValue: localeList[localeKey],
          getValueProps: function getValueProps(value) {
            return {
              value: localeList[localeKey]
            };
          },
          rules: [{
            required: !!(localeKey == locale),
            message: modalLocale.errorMsg
          }],
          onChange: function onChange(v) {
            var _localeList = _this3.state._localeList;
            _localeList[localeKey] = v;

            _this3.setState({
              _localeList: _localeList
            });
          }
        }), {
          onFocus: function onFocus() {
            var obj = _this3.state.inputFocused;
            obj[localeKey] = true;

            _this3.setState({
              inputFocused: obj
            });
          },
          onBlur: function onBlur() {
            var obj = _this3.state.inputFocused;
            obj[localeKey] = false;

            _this3.setState({
              inputFocused: obj
            });
          },
          onClick: function onClick(e) {
            e.stopPropagation();
          }
        })), _this3.props.showIcon ? _react["default"].createElement("div", {
          className: "input-icon",
          fieldid: _this3.props.fieldid + '_open',
          onClick: _this3.open
        }) : '');

        var input = null;

        if (localeKey == locale) {
          input = _react["default"].createElement(_nextUi.Popover, {
            className: "input-tip-pover",
            overlayClassName: "mdf-popover input-tip-pover-dialog inputmultilang-cn",
            content: err || _this3.state.error ? msg : '',
            placement: "top",
            trigger: "hover"
          }, _input);
        } else {
          input = _input;
        }

        return _react["default"].createElement("div", {
          className: isTextarea ? 'edit-panel edit-panel-all textAreaPopover' : 'edit-panel edit-panel-all',
          key: localeKey
        }, _react["default"].createElement(FormItem, null, _react["default"].createElement("div", {
          className: "wui-form-item-label"
        }, _react["default"].createElement("label", {
          className: "wui-label",
          title: modalLocale.label[localeKey],
          style: {
            'width': '140px'
          }
        }, _react["default"].createElement("span", {
          style: {
            'float': 'right'
          }
        }, modalLocale.label[localeKey], transLanguage(localeKey)), _this3.renderLabelright(localeKey))), _react["default"].createElement("div", {
          style: {
            'display': 'inline-block',
            'width': 'calc(100% - 150px)',
            'marginLeft': '10px'
          },
          className: _this3.state.inputFocused[localeKey] ? 'focus' : ''
        }, input)));
      });
    }
  }, {
    key: "getTipMessage",
    value: function getTipMessage(modalLocale, locale, sysLocale, translateFun) {
      return _react["default"].createElement("div", {
        className: "tip-message"
      }, _react["default"].createElement("p", {
        className: "lang-message"
      }, modalLocale.curLanguage, "\uFF1A", _react["default"].createElement("span", {
        className: "lang"
      }, modalLocale.label[locale]), modalLocale.enterpriseLang, "\uFF1A", _react["default"].createElement("span", {
        className: "lang"
      }, modalLocale.label[sysLocale])));
    }
  }, {
    key: "equalLang",
    value: function equalLang(obj1, obj2) {
      var _equal = function _equal(obj1, obj2) {
        try {
          for (var _key3 in obj1) {
            if (obj1[_key3] != obj2[_key3]) {
              return false;
            }
          }
        } catch (e) {
          return false;
        }

        return true;
      };

      return _equal(obj1, obj2) && _equal(obj2, obj1);
    }
  }, {
    key: "onChange",
    value: function onChange(localeValue, localeList, bShowModal) {
      var _this$state4 = this.state,
          sysLocale = _this$state4.sysLocale,
          locale = _this$state4.locale;
      localeList[locale] = localeValue;

      if (bShowModal) {
        if (!localeList[sysLocale]) {
          localeList[sysLocale] = localeValue;
        }
      }

      if (this.firstClickIcon && sysLocale) localeList[sysLocale] = localeValue;
      if (this.props.forceSync) localeList = this.forceSyncChange(localeList, localeValue);
      this.props.onChange && this.props.onChange(localeValue, localeList);
      this.setState({
        localeValue: localeValue,
        _localeList: JSON.parse(JSON.stringify(localeList))
      });
    }
  }, {
    key: "onSelect",
    value: function onSelect(localeValue, localeList, item) {
      localeList[this.state.locale] = localeValue;
      if (this.props.forceSync) localeList = this.forceSyncChange(localeList, localeValue);
      this.props.onSelect && this.props.onSelect(localeValue, localeList, item);
      this.setState({
        localeValue: localeValue,
        _localeList: JSON.parse(JSON.stringify(localeList))
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(localeValue, localeList) {
      console.debug('%c[inputmultilang] [AcInputLocale] [onBlur()] begin...', 'color:blue');
      localeList[this.state.locale] = localeValue;

      if (!this.isMouseEnterIcon) {
        if (this.props.onBlur) {
          this.props.onBlur(localeValue, localeList);
          console.debug('%c[inputmultilang] [AcInputLocale] [onBlur()] this.props.onBlur() is fired', 'color:blue');
        }

        this.setState({
          focused: false
        });
      }
    }
  }, {
    key: "onPressEnter",
    value: function onPressEnter(localeList) {
      if (!this.isMouseEnterIcon) {
        this.props.onPressEnter && this.props.onPressEnter(localeList);
        this.setState({
          focused: false
        });
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      this.props.onFocus && this.props.onFocus();
      this.setState({
        focused: true
      });
    }
  }, {
    key: "getRequireInputContrl",
    value: function getRequireInputContrl(isAutoComplete, params) {
      var msg = this.props.msg;

      var _input = isAutoComplete ? this.getRequireAutoCompleteInput(params) : this.getRequireNoAutoCompleteInput(params);

      return msg ? _react["default"].createElement(_nextUi.Popover, {
        className: "input-tip-pover",
        overlayClassName: "mdf-popover input-tip-pover-dialog inputmultilang-pover",
        content: msg,
        placement: "top",
        trigger: "hover"
      }, _input) : _input;
    }
  }, {
    key: "getInputControl",
    value: function getInputControl(isAutoComplete, params) {
      return isAutoComplete ? this.getAutoCompleteInput(params) : this.getNoAutoCompleteInput(params);
    }
  }, {
    key: "getRequireAutoCompleteInput",
    value: function getRequireAutoCompleteInput(params) {
      var _this4 = this;

      var self = this;
      var disabled = params.disabled,
          forceSync = params.forceSync,
          placeholder = params.placeholder,
          localeValue = params.localeValue,
          locale = params.locale,
          localeList = params.localeList,
          sysLocale = params.sysLocale,
          getFieldProps = params.getFieldProps,
          options = params.options,
          cItemName = params.cItemName;
      var combineKeys = options && options.length && options[0].combineKeys || [];
      return _react["default"].createElement(_nextUi.Select, {
        className: "input-text",
        mode: "combobox",
        value: localeValue,
        allowClear: true,
        dropdownClassName: "mdf-autocomplete-drop",
        disabled: disabled,
        filterOption: false,
        onSearch: function onSearch(value) {
          var _value, _value$target;

          value = typeof value === 'string' ? value : (_value = value) === null || _value === void 0 ? void 0 : (_value$target = _value.target) === null || _value$target === void 0 ? void 0 : _value$target.value;
          localeList[locale] = value;
          if (forceSync) localeList = self.forceSyncChange(localeList, value);
          self.onChange && self.onChange(value, localeList);

          if (!_this4.equalLang(localeList, _this4.state.localeList)) {
            _this4.setState({
              localeValue: value,
              localeList: localeList,
              inputError: ''
            });
          }
        },
        onBlur: function onBlur(value) {
          var _value2, _value2$target;

          value = typeof value === 'string' ? value : (_value2 = value) === null || _value2 === void 0 ? void 0 : (_value2$target = _value2.target) === null || _value2$target === void 0 ? void 0 : _value2$target.value;
          if (_this4.isMouseEnterIcon) return;

          if (_this4.props.showIcon && !localeList[sysLocale]) {
            localeList[sysLocale] = value;
          }

          localeList[locale] = value;

          if (forceSync) {
            localeList = self.forceSyncChange(localeList, value);
          }

          self.onBlur && self.onBlur(value, localeList);

          if (!_this4.equalLang(localeList, _this4.state.localeList)) {
            _this4.setState({
              localeValue: value,
              localeList: localeList
            });
          }
        },
        onSelect: function onSelect(value, _ref) {
          var _value3, _value3$target;

          var item = _ref.props.item;
          value = typeof value === 'string' ? value : (_value3 = value) === null || _value3 === void 0 ? void 0 : (_value3$target = _value3.target) === null || _value3$target === void 0 ? void 0 : _value3$target.value;

          if (_this4.props.showIcon && !localeList[sysLocale]) {
            localeList[sysLocale] = value;
          }

          localeList[locale] = value;
          self.onSelect && self.onSelect(value, localeList, item);

          if (!_this4.equalLang(localeList, _this4.state.localeList)) {
            _this4.setState({
              localeValue: value,
              localeList: localeList
            });
          }
        },
        placeholder: placeholder,
        onFocus: function onFocus(e) {
          return self.onFocus(e);
        }
      }, options && options.length && options.map(function (item) {
        var itemTitle = '';

        if (combineKeys.length) {
          combineKeys.forEach(function (key, index) {
            if (index > 0) {
              itemTitle = itemTitle + ' ' + item[key];
            } else {
              itemTitle += item[key];
            }
          });
        } else {
          itemTitle = item[cItemName];
        }

        return _react["default"].createElement(Option, {
          key: item.id,
          className: "mdf-autocomplete",
          value: itemTitle,
          item: item
        }, itemTitle);
      }));
    }
  }, {
    key: "getAutoCompleteInput",
    value: function getAutoCompleteInput(params) {
      this.getRequireAutoCompleteInput(params);
    }
  }, {
    key: "getNoAutoCompleteInput",
    value: function getNoAutoCompleteInput(params) {
      var _this5 = this;

      var self = this;
      var isTextarea = params.isTextarea,
          forceSync = params.forceSync,
          placeholder = params.placeholder,
          maxLength = params.maxLength,
          localeValue = params.localeValue,
          locale = params.locale,
          localeList = params.localeList,
          sysLocale = params.sysLocale,
          disabled = params.disabled,
          focused = params.focused;
      var formControlTypeOption = {};
      var selfProps = {
        isTextarea: isTextarea
      };

      if (this.state.focused) {
        selfProps.focus = true;
      }

      return _react["default"].createElement(_FormInputControl["default"], (0, _extends2["default"])({}, selfProps, {
        className: "input-text",
        fieldid: this.props.fieldid + '_noAutoComplete',
        value: localeValue,
        disabled: disabled
      }, formControlTypeOption, {
        onChange: function onChange(value) {
          localeList[locale] = value;
          if (forceSync) localeList = self.forceSyncChange(localeList, value);
          self.onChange && self.onChange(value, localeList);

          if (!_this5.equalLang(localeList, _this5.state.localeList)) {
            _this5.setState({
              localeValue: value,
              localeList: localeList
            });
          }
        },
        onBlur: function onBlur(value) {
          if (_this5.isMouseEnterIcon) return;

          if (_this5.props.showIcon && !localeList[sysLocale]) {
            localeList[sysLocale] = value;
          }

          localeList[locale] = value;

          if (forceSync) {
            localeList = self.forceSyncChange(localeList, value);
          }

          self.onBlur && self.onBlur(value, localeList);

          if (!_this5.equalLang(localeList, _this5.state.localeList)) {
            _this5.setState({
              localeValue: value,
              localeList: localeList
            });
          }
        },
        onKeyDown: function onKeyDown(e) {
          var _this5$props$onKeyDow, _this5$props;

          if (_this5.isMouseEnterIcon) return;
          var value = e.target.value;

          if (e.keyCode == 13 && _this5.props.showIcon && !localeList[sysLocale]) {
            localeList[sysLocale] = value;
          }

          localeList[locale] = value;

          if (forceSync) {
            localeList = self.forceSyncChange(localeList, value);
          }

          if (e.keyCode == 13) {
            self.onPressEnter && self.onPressEnter(localeList);

            if (!_this5.equalLang(localeList, _this5.state.localeList)) {
              _this5.setState({
                localeValue: value,
                localeList: localeList
              });
            }
          }

          (_this5$props$onKeyDow = (_this5$props = _this5.props).onKeyDown) === null || _this5$props$onKeyDow === void 0 ? void 0 : _this5$props$onKeyDow.call(_this5$props, e, localeList);
        },
        placeholder: placeholder,
        maxLength: maxLength,
        onFocus: function onFocus(e) {
          return self.onFocus(e);
        },
        onClick: function onClick(e) {
          e.stopPropagation();
        },
        ref: function ref(input) {
          _this5.textInput = input;
        }
      }));
    }
  }, {
    key: "getRequireNoAutoCompleteInput",
    value: function getRequireNoAutoCompleteInput(params) {
      var _this6 = this;

      var isTextarea = params.isTextarea,
          disabled = params.disabled,
          forceSync = params.forceSync,
          placeholder = params.placeholder,
          maxLength = params.maxLength,
          localeValue = params.localeValue,
          locale = params.locale,
          localeList = params.localeList,
          sysLocale = params.sysLocale,
          focused = params.focused,
          getFieldProps = params.getFieldProps;
      var self = this;
      var selfProps = {
        isTextarea: isTextarea
      };

      if (focused) {
        selfProps.focus = true;
      }

      return _react["default"].createElement(_FormInputControl["default"], (0, _extends2["default"])({}, selfProps, {
        className: "input-text",
        fieldid: this.props.fieldid + '_requireNoAutoComplete',
        disabled: disabled
      }, getFieldProps(this.props.inputId, {
        getValueProps: function getValueProps(value) {
          return {
            value: localeValue
          };
        },
        initialValue: localeValue
      }), {
        onChange: function onChange(value) {
          console.debug('%c[inputmultilang] [AcInputLocale] [getRequireNoAutoCompleteInput()] onChange() begin...', 'color:blue');
          localeList[locale] = value;
          if (forceSync) localeList = self.forceSyncChange(localeList, value);
          self.onChange && self.onChange(value, localeList);

          if (!_this6.equalLang(localeList, _this6.state.localeList)) {
            _this6.setState({
              localeValue: value,
              localeList: localeList,
              inputError: ''
            });
          }
        },
        onBlur: function onBlur(value) {
          console.debug('%c[inputmultilang] [AcInputLocale] [getRequireNoAutoCompleteInput()] onBlur() begin...', 'color:blue');

          if (_this6.isMouseEnterIcon) {
            console.debug('%c[inputmultilang] [AcInputLocale] [getRequireNoAutoCompleteInput()] onBlur() return as this.isMouseEnterIcon is true', 'color:blue');
            return;
          }

          if (_this6.props.showIcon && !localeList[sysLocale]) {
            localeList[sysLocale] = value;
          }

          localeList[locale] = value;

          if (forceSync) {
            localeList = self.forceSyncChange(localeList, value);
          }

          if (self.onBlur) {
            console.debug('%c[inputmultilang] [AcInputLocale] [getRequireNoAutoCompleteInput()] [onBlur()] self.onBlur() will be invoked', 'color:blue');
            self.onBlur(value, localeList);
          }

          if (!_this6.equalLang(localeList, _this6.state.localeList)) {
            _this6.setState({
              localeValue: value,
              localeList: localeList
            });
          }
        },
        onKeyDown: function onKeyDown(e) {
          var _this6$props$onKeyDow, _this6$props;

          console.debug('%c[inputmultilang] [AcInputLocale] [getRequireNoAutoCompleteInput()] [onKeyDown()] begin...', 'color:blue');
          if (_this6.isMouseEnterIcon) return;
          var value = e.target.value;

          if (e.keyCode == 13 && _this6.props.showIcon && !localeList[sysLocale]) {
            localeList[sysLocale] = value;
          }

          localeList[locale] = value;

          if (forceSync) {
            localeList = self.forceSyncChange(localeList, value);
          }

          if (e.keyCode == 13) {
            if (self.onPressEnter) {
              console.debug('%c[inputmultilang] [AcInputLocale] [getRequireNoAutoCompleteInput()] [onKeyDown()] self.onPressEnter() will be invoked', 'color:blue');
              self.onPressEnter(localeList);
            }

            if (!_this6.equalLang(localeList, _this6.state.localeList)) {
              _this6.setState({
                localeValue: value,
                localeList: localeList
              });
            }
          }

          (_this6$props$onKeyDow = (_this6$props = _this6.props).onKeyDown) === null || _this6$props$onKeyDow === void 0 ? void 0 : _this6$props$onKeyDow.call(_this6$props, e, localeList);
        },
        placeholder: placeholder,
        maxLength: maxLength,
        onFocus: function onFocus(e) {
          return self.onFocus(e);
        },
        onClick: function onClick(e) {
          e.stopPropagation();
        },
        ref: function ref(input) {
          _this6.textInput = input;
        }
      }));
    }
  }, {
    key: "_renderModalInputLocal",
    value: function _renderModalInputLocal() {
      var _this7 = this;

      var _this$props5 = this.props,
          isTextarea = _this$props5.isTextarea,
          forceSync = _this$props5.forceSync,
          placeholder = _this$props5.placeholder,
          maxLength = _this$props5.maxLength,
          className = _this$props5.className,
          backdrop = _this$props5.backdrop,
          disabled = _this$props5.disabled,
          isAutoComplete = _this$props5.isAutoComplete,
          options = _this$props5.options,
          translateFun = _this$props5.translateFun,
          getContainer = _this$props5.getContainer;
      var _this$state5 = this.state,
          localeValue = _this$state5.localeValue,
          locale = _this$state5.locale,
          localeList = _this$state5.localeList,
          _localeList = _this$state5._localeList,
          status = _this$state5.status,
          modalLocale = _this$state5.modalLocale,
          sysLocale = _this$state5.sysLocale,
          focused = _this$state5.focused;
      var defaultValue;

      if (localeList && localeList[sysLocale]) {
        defaultValue = localeList[sysLocale];
      }

      var params = {
        isTextarea: isTextarea,
        forceSync: forceSync,
        placeholder: placeholder,
        maxLength: maxLength,
        localeValue: localeValue,
        locale: locale,
        localeList: localeList,
        sysLocale: sysLocale,
        focused: focused,
        options: options,
        disabled: disabled
      };
      var showLanguage = transLanguage(locale);
      var isShowTip = modalLocale.inputTips && locale !== sysLocale;
      return _react["default"].createElement("div", {
        className: "ac-input-locale ".concat(className ? className : null)
      }, status === 'preview' ? this.getPreviewElement(localeValue, defaultValue, localeList, modalLocale, locale) : isTextarea ? _react["default"].createElement("div", {
        className: disabled ? 'wui-input-disabled textareaField' : 'textareaField'
      }, this.getInputControl(isAutoComplete, params), this.props.showIcon ? _react["default"].createElement("div", {
        className: "input-icon",
        fieldid: this.props.fieldid + '_open',
        onClick: disabled ? function () {} : function (e) {
          _this7.showIconClick(e, _localeList);
        },
        onMouseEnter: this.onMouseEnterIcon,
        onMouseLeave: this.onMouseLeaveIcon
      }, showLanguage) : '') : _react["default"].createElement("div", {
        className: disabled ? 'wui-input-disabled' : ''
      }, this.getInputControl(isAutoComplete, params), this.props.showIcon ? _react["default"].createElement("div", {
        className: "input-icon",
        fieldid: this.props.fieldid + '_open',
        onClick: disabled ? function () {} : function (e) {
          _this7.showIconClick(e, _localeList);
        },
        onMouseEnter: this.onMouseEnterIcon,
        onMouseLeave: this.onMouseLeaveIcon
      }, showLanguage) : ''), _react["default"].createElement(_modal["default"], {
        container: getContainer,
        fieldid: this.props.fieldid + '_modal',
        serviceCode: this.state.serviceCode,
        title: modalLocale.title,
        showModal: this.state.showModal,
        backdrop: backdrop,
        cancelName: modalLocale.cancelName,
        onOk: this.onOk,
        onCancel: this.onCancel,
        okName: modalLocale.okName,
        close: this.onClose
      }, isShowTip && _react["default"].createElement("div", {
        className: "modalTip"
      }, _react["default"].createElement(_nextUi.Icon, {
        type: "xingzhuangbeifen"
      }), translateSplitCode('UID:P_MDF-COMPS_177553A405680006', translateFun, {
        enterprise: modalLocale.label[sysLocale],
        current: modalLocale.label[locale]
      })), this.getTipMessage(modalLocale, locale, sysLocale, translateFun), this.getLocaleNoFormElement(_localeList, modalLocale, locale)));
    }
  }, {
    key: "_renderModalRequireInputLocal",
    value: function _renderModalRequireInputLocal() {
      var _this8 = this;

      var _this$props6 = this.props,
          isTextarea = _this$props6.isTextarea,
          className = _this$props6.className,
          disabled = _this$props6.disabled,
          forceSync = _this$props6.forceSync,
          placeholder = _this$props6.placeholder,
          backdrop = _this$props6.backdrop,
          maxLength = _this$props6.maxLength,
          isAutoComplete = _this$props6.isAutoComplete,
          options = _this$props6.options,
          translateFun = _this$props6.translateFun,
          cItemName = _this$props6.cItemName,
          getContainer = _this$props6.getContainer;
      var _this$state6 = this.state,
          localeValue = _this$state6.localeValue,
          locale = _this$state6.locale,
          localeList = _this$state6.localeList,
          _localeList = _this$state6._localeList,
          status = _this$state6.status,
          modalLocale = _this$state6.modalLocale,
          sysLocale = _this$state6.sysLocale,
          focused = _this$state6.focused;
      var defaultValue;

      if (localeList && localeList[sysLocale]) {
        defaultValue = localeList[sysLocale];
      }

      var getFieldProps = this.props.form.getFieldProps;
      var getFieldError = this.props.form.getFieldError;
      var params = {
        isTextarea: isTextarea,
        disabled: disabled,
        forceSync: forceSync,
        placeholder: placeholder,
        maxLength: maxLength,
        localeValue: localeValue,
        locale: locale,
        localeList: localeList,
        sysLocale: sysLocale,
        focused: focused,
        getFieldProps: getFieldProps,
        options: options,
        cItemName: cItemName
      };
      var showLanguage = transLanguage(locale);
      var isShowTip = modalLocale.inputTips && locale !== sysLocale;
      return _react["default"].createElement("div", {
        className: "ac-input-locale ".concat(className ? className : null)
      }, status === 'preview' ? this.getPreviewElement(localeValue, defaultValue, localeList, modalLocale, locale) : isTextarea ? _react["default"].createElement("div", {
        className: disabled ? 'wui-input-disabled textareaField' : 'textareaField'
      }, this.getRequireInputContrl(isAutoComplete, params), this.props.showIcon ? _react["default"].createElement("div", {
        className: "input-icon",
        fieldid: this.props.fieldid + '_open',
        onClick: disabled ? function () {} : function (e) {
          _this8.showIconClick(e, _localeList);
        },
        onMouseEnter: this.onMouseEnterIcon,
        onMouseLeave: this.onMouseLeaveIcon
      }, showLanguage) : '') : _react["default"].createElement("div", {
        className: disabled ? 'wui-input-disabled' : ''
      }, this.getRequireInputContrl(isAutoComplete, params), this.props.showIcon ? _react["default"].createElement("div", {
        className: "input-icon",
        fieldid: this.props.fieldid + '_open',
        onClick: disabled ? function () {} : function (e) {
          _this8.showIconClick(e, _localeList);
        },
        onMouseEnter: this.onMouseEnterIcon,
        onMouseLeave: this.onMouseLeaveIcon
      }, showLanguage) : ''), _react["default"].createElement(_modal["default"], {
        container: getContainer,
        fieldid: this.props.fieldid + '_modal',
        serviceCode: this.state.serviceCode,
        title: modalLocale.title,
        showModal: this.state.showModal,
        backdrop: backdrop,
        cancelName: modalLocale.cancelName,
        onOk: this.onOk,
        onCancel: this.onCancel,
        okName: modalLocale.okName,
        close: this.onClose
      }, isShowTip && _react["default"].createElement("div", {
        className: "modalTip"
      }, _react["default"].createElement(_nextUi.Icon, {
        type: "xingzhuangbeifen"
      }), translateSplitCode('UID:P_MDF-COMPS_177553A405680006', translateFun, {
        enterprise: modalLocale.label[sysLocale],
        current: modalLocale.label[locale]
      })), this.getTipMessage(modalLocale, locale, sysLocale, translateFun), this.getLocaleFormElement(_localeList, modalLocale, locale, getFieldProps, getFieldError)));
    }
  }, {
    key: "render",
    value: function render() {
      var required = this.state.required;

      if (required || this.props.msg) {
        return this._renderModalRequireInputLocal();
      } else {
        return this._renderModalInputLocal();
      }
    }
  }]);
  return AcInputLocale;
}(_react.Component);

AcInputLocale.propTypes = propTypes;
AcInputLocale.defaultProps = defaultProps;

var _default = _nextUi.Form.create({})(AcInputLocale);

exports["default"] = _default;
//# sourceMappingURL=index.js.map